import { createStyles } from 'antd-style'

export const useStyle = createStyles(({ token }) => ({
  serviceRow: {
    padding: '10px 12px',
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadius
  },
  serviceRowSelected: {
    borderColor: token.colorPrimary
  },
  clientRowLocked: {
    opacity: 0.5
  },
  clientHeader: {
    all: 'unset',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    cursor: 'pointer',
    color: token.colorText,
    '&:disabled': { cursor: 'not-allowed' },
    '&:focus-visible': {
      outline: `2px solid ${token.colorPrimary}`,
      outlineOffset: 2,
      borderRadius: token.borderRadiusSM
    }
  },
  clientLogo: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    flex: 'none',
    borderRadius: token.borderRadius,
    background: token.colorFillTertiary
  }
}))
